///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/apps/userSettings/tabManager"/>
const tabs:any[] = [];

export function register(tab:any) {
    tabs.push(tab);
}

export function getTabs() {
    return tabs;
}